import { useCallback } from "react"

import { useTranslation } from "@l2r-front/l2r-i18n"
import { LINEAR_LOCATION_ROAD, LINEAR_LOCATION_SECTION, useNetworksStateContext } from "@l2r-front/l2r-networks"

import { I18N_NAMESPACE } from "../../constants/i18n"
import { BASE_ATTACHMENTS, NETWORK_ATTACHMENT, SECTION_ATTACHMENT } from "../../constants/modules"
import { useDocumentCreate } from "../../hooks/mutations/useDocumentCreate"
import { useDocumentModuleCreate } from "../../hooks/mutations/useDocumentModuleCreate"

import { DocumentForm } from "../DocumentForm"

export const DocumentAddForm = (props) => {

    const {
        attachedObjectId,
        attachedObjectType,
        documentLocation,
        onClose,
        onSubmitting,
        onChange,
        selectionType,
    } = props

    const { t } = useTranslation(I18N_NAMESPACE)
    const { selectedNetwork } = useNetworksStateContext()

    const documentMutation = useDocumentCreate({}, {
        errorSnackbarMessage: t(I18N_NAMESPACE, "containers.documentAddForm.snackbar.error"),
        successSnackbarMessage: t(I18N_NAMESPACE, "containers.documentAddForm.snackbar.success"),
        onSuccess: () => onClose(false),
        onError: () => {
            onSubmitting(false)
        },
    })

    const moduleMutation = useDocumentModuleCreate(attachedObjectType, attachedObjectId, {
        errorSnackbarMessage: t(I18N_NAMESPACE, "containers.documentAddForm.snackbar.error"),
        successSnackbarMessage: t(I18N_NAMESPACE, "containers.documentAddForm.snackbar.success"),
        onSuccess: () => onClose(false),
        onError: () => {
            onSubmitting(false)
        },
    })

    const onSubmit = useCallback((formValues) => {
        const type = selectionType.toLowerCase()
        const isModuleAttachment = !BASE_ATTACHMENTS.includes(type)
        const mutation = isModuleAttachment ? moduleMutation : documentMutation
        mutation.mutate({
            ...formValues,
            ...(type === NETWORK_ATTACHMENT && { attached_object_content_type: selectionType }),
            ...(documentLocation && {
                linear_location_type_data: JSON.stringify({
                    road_type: type === SECTION_ATTACHMENT ? LINEAR_LOCATION_SECTION : LINEAR_LOCATION_ROAD,
                    ...(documentLocation || {}),
                }),
            }),
            ...(attachedObjectId && { attached_object_uuid: attachedObjectId }),
            ...(type === NETWORK_ATTACHMENT && { attached_object_uuid: selectedNetwork.uuid }),
        })
        onSubmitting(true)
    }, [attachedObjectId, documentLocation, documentMutation, moduleMutation, onSubmitting, selectionType, selectedNetwork])

    return <DocumentForm
        isSubmitting={documentMutation.isPending || moduleMutation.isPending}
        onSubmit={onSubmit}
        onCancel={() => onClose()}
        onChange={onChange}
    />
}